<template>
  <a-modal
    ref="createModal"
    title="标签明细"
    :width="950"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
    :footer="null"
  >
    <a-spin :spinning="loading">
      <lsMetable
        class="editMaterial"
        :columns="detailCols"
        :data-list="detailList"
        :scroll="{ y:300 }"
        :IsEdit="false"
        :need-add="false"
      >
        <template #requisitionCode="{ text, record }">
          <a href="javascript:;" @click="onShowDetail(record)">{{ text }}</a>
        </template>
      </lsMetable>
    </a-spin>
  </a-modal>
</template>

<script>
import { apiGetLabelIDetailList } from '@/api/mes/workOrderManage/moTickets'
export default {
  name: 'ReceivedQuantityModal',
  props: {
    mainBtnLoading: Boolean
  },
  data () {
    return {
      loading: false,
      visible: false,
      detailList: [],
      detailCols: [
        { dataIndex: 'itemCode', title: '物料编码' },
        { dataIndex: 'label', title: '标签号' },
        { dataIndex: 'lotNumber', title: '生产批次号' },
        { dataIndex: 'qty', title: '已领数量' },
        { dataIndex: 'backQty', title: '退料数量' }
      ]
    }
  },
  methods: {
    show (id) {
      this.visible = true;
      this.getDataList(id);
    },
    getDataList(detailId) {
      this.detailList = [];
      this.loading = true;
      apiGetLabelIDetailList({ detailId }).then(res => {
        if(res.code === 200) {
          this.detailList = res.data || [];
        }else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 关闭模态框
    onClose () {
      this.visible = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.detailList = [];
    }
  }
}
</script>

<style  scoped lang="less">
</style>
